(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/accordion/assets/javascripts/accordion.js') >= 0) return;  svs.modules.push('/components/ui/accordion/assets/javascripts/accordion.js');

'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.ui = svs.ui || {};
svs.ui.accordion = svs.ui.accordion || {};
svs.ui.Accordion = function () {
  function Accordion(options) {
    var _this = this;
    _classCallCheck(this, Accordion);
    this.log = svs.core.log.getLogger('ui:accordion');
    this.options = options;

    if (options.items && options.items.length && options.el) {
      this.renderItems(options, function () {
        _this.initAccordion(options, function () {
          _this.setUpListeners(options);
        });
      });
    } else {
      this.initAccordion(options, function () {
        _this.setUpListeners(options);
      });
    }
  }
  return _createClass(Accordion, [{
    key: "initAccordion",
    value: function initAccordion(options, callback) {
      var $el = (options === null || options === void 0 ? void 0 : options.el) || undefined;
      var accordionEl;
      if ($el) {
        if ($el instanceof Element) {
          if ($el.classList.contains('js-accordion')) {
            accordionEl = $el;
          } else {
            accordionEl = $el.querySelector('.js-accordion');
          }
        } else if (document.querySelector(".js-accordion.".concat($el))) {
          accordionEl = document.querySelector(".js-accordion.".concat($el));
        } else {
          accordionEl = document.querySelector(".".concat($el)).querySelector(".js-accordion");
        }
        this.animations = svs.ui.Accordion.AccordionAnimations;
        this.options = {
          accordionEl: accordionEl,
          clickCallback: (options === null || options === void 0 ? void 0 : options.clickCallback) || false,
          branding: (options === null || options === void 0 ? void 0 : options.branding) || false,
          customer: (options === null || options === void 0 ? void 0 : options.customer) || 'neutral',
          allowMultipleOpen: (options === null || options === void 0 ? void 0 : options.allowMultipleOpen) || false,
          items: accordionEl.querySelectorAll('.js-accordion-item'),
          throttled: false
        };
        for (var i = 0; i < this.options.items.length; i++) {
          if (this.options.items[i].getAttribute('aria-expanded') === 'true') {
            this.options.items[i].setAttribute('aria-expanded', 'false');
            this.handleChange(this.options.items[i], null);
          }
        }
        callback();
      } else {
        this.log.error('No el found in options object for Accordion.');
      }
    }

  }, {
    key: "setUpListeners",
    value: function setUpListeners() {
      var _this2 = this;
      var self = this;
      var _loop = function _loop(i) {
        _this2.options.items[i].classList.add("js-accordion-item-".concat(i));
        _this2.options.items[i].querySelector('.js-accordion-details').id = _this2.options.items[i].getAttributeNode('aria-controls').nodeValue;
        _this2.options.items[i].dataset.index = i;
        _this2.options.items[i].querySelector('.js-accordion-summary').addEventListener('click', function (e) {
          self.handleChange(_this2.options.items[i], e);
        });
        _this2.options.items[i].addEventListener('keydown', function (e) {
          self.handleKeyDown(e);
        });
      };
      for (var i = 0; i < this.options.items.length; i++) {
        _loop(i);
      }
    }

  }, {
    key: "handleChange",
    value: function handleChange(el, evt) {
      var self = this;
      if (!self.options.throttled) {
        var expanded;
        var details = el.querySelector('.js-accordion-details');
        self.options.throttled = true;
        if (el.getAttribute('aria-expanded') === 'false') {
          el.setAttribute('aria-expanded', 'true');
          details.ariaHidden = 'false';
          expanded = true;
        } else {
          el.setAttribute('aria-expanded', 'false');
          details.ariaHidden = 'true';
          expanded = false;
        }
        self.animations.toggleAccordionAnimate(self.options.customer, expanded, el);
        self.animations.handleNeighbors(el, expanded, parseInt(el.dataset.index, 10));

        if (!this.options.allowMultipleOpen) {
          for (var i = 0; i < self.options.items.length; i++) {
            if (self.options.items[i].ariaExpanded !== 'false' && self.options.items[i] !== el) {
              self.options.items[i].setAttribute('aria-expanded', 'false');
              self.options.items[i].querySelector('.js-accordion-details').ariaHidden = 'true';
              self.animations.toggleAccordionAnimate(self.options.customer, false, self.options.items[i]);
              self.animations.handleNeighbors(self.options.items[i], false, parseInt(self.options.items[i].dataset.index, 10));
            }
          }
        }
        if (self.options.clickCallback) {
          evt.stopImmediatePropagation();
          self.options.clickCallback(self.getItemAttributes(evt), evt);
        }
        self.options.throttled = false;
      }
    }

  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var SPACEBAR_KEY_CODE = 32;
      var ENTER_KEY = 13;
      var ESCAPE_KEY_CODE = 27;
      switch (e.keyCode) {
        case SPACEBAR_KEY_CODE:
        case ENTER_KEY:
          e.preventDefault();
          this.handleChange(e.currentTarget, e);
          return;
        case ESCAPE_KEY_CODE:
          e.preventDefault();
          if (e.target.parentElement.getAttribute('aria-expanded') === 'true') {
            this.handleChange(e.currentTarget, e);
          }
          break;
        default:
      }
    }

  }, {
    key: "renderItems",
    value: function renderItems(options, callback) {
      if (options.el && options !== null && options !== void 0 && options.items.length) {
        var items = [];
        var summary;
        var details;
        for (var i = 0; i < options.items.length; i++) {
          summary = svs.ui.accordion.partials.accordion_summary({
            content: options.items[i].summary
          });
          details = svs.ui.accordion.partials.accordion_details({
            content: options.items[i].details
          });
          items.push(svs.ui.accordion.partials.accordion_item({
            class: options.items[i].class,
            isFlat: options.items[i].isFlat,
            expanded: options.items[i].expanded === undefined ? false : options.items[i].expanded,
            __uniqueId: Math.round(Math.random() * 100000 + 1000 + i),
            content: summary += details
          }));
        }
        var accordion = svs.ui.accordion.partials.accordion({
          class: options.class,
          customer: options.customer,
          branding: options.branding,
          items: items
        });
        if (options.el instanceof Element) {
          options.el.innerHTML = accordion;
        } else {
          document.querySelector(".".concat(options.el)).innerHTML = accordion;
        }
        callback();
      }
    }

  }, {
    key: "getItemAttributes",
    value: function getItemAttributes(evt) {
      evt.preventDefault();
      var item = {};
      var attributes = evt.currentTarget.attributes;
      for (var i = 0; i < attributes.length; i++) {
        item[attributes[i].name] = attributes[i].value;
      }
      return item;
    }
  }]);
}();

 })(window);